import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useToast } from "../lib/toast";

export default function Login() {
  const { login } = useAuth();
  const { push } = useToast();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const user = await login(email, password);
      push(`${user.company_name} 환영합니다`, "success");
      nav(user.role === "admin" ? "/admin" : "/catalog");
    } catch (e: any) {
      setErr(e.message);
      push(e.message, "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 440, padding: "60px 20px" }}>
      <div className="card" style={{ padding: 32 }}>
        <h1 className="h-title" style={{ marginBottom: 8 }}>로그인</h1>
        <p className="muted" style={{ marginBottom: 24 }}>승인된 사업자 계정만 이용 가능합니다.</p>
        <form onSubmit={submit} className="stack">
          <label>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>이메일</div>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          </label>
          <label>
            <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 6 }}>비밀번호</div>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          {err && <div style={{ fontSize: 15, color: "var(--danger)", padding: "8px 12px", background: "#fce1dc", borderRadius: 4 }}>{err}</div>}
          <button className="btn btn-primary" disabled={busy}>{busy ? "로그인 중..." : "로그인"}</button>
        </form>
        <div style={{ marginTop: 20, fontSize: 15, textAlign: "center" }}>
          아직 회원이 아니신가요? <Link to="/signup" style={{ color: "var(--accent)", fontWeight: 600 }}>회원가입</Link>
        </div>
      </div>
    </div>
  );
}
